import "../styles/form_access.css";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TOKEN_KEY = "css_access_token";
const BASE = "/festivalaki/registration-26-css";

async function validate(token) {
	if (!token) return false;
	try {
		const r = await fetch(`${BASE}/access/validate`, { headers: { "x-css-access": token } });
		const j = await r.json();
		return !!j.valid;
	} catch {
		return false;
	}
}

export function CssFormGuard({ children }) {
	const [token] = useState(() => sessionStorage.getItem(TOKEN_KEY) || "");
	const [checking, setChecking] = useState(true);
	const [valid, setValid] = useState(false);
	const navigate = useNavigate();
	const loc = useLocation();

	useEffect(() => {
		let cancel = false;
		(async () => {
			const ok = await validate(token);
			if (cancel) return;
			setValid(ok);
			setChecking(false);
			if (!ok) {
				const next = encodeURIComponent(loc.pathname + loc.search);
				navigate(`/festivalaki/registration-26-css-access?next=${next}`, { replace: true });
			}
		})();
		return () => {
			cancel = true;
		};
	}, [token, navigate, loc.pathname, loc.search]);

	if (checking) {
		return (
			<div className="page-container">
				<h2>Loading…</h2>
				<p>Verifying access.</p>
			</div>
		);
	}
	if (!valid) return null;
	return React.cloneElement(children, { cssAccessToken: token });
}

export function CssAccessPage() {
	const navigate = useNavigate();
	const loc = useLocation();
	const params = new URLSearchParams(loc.search);
	const next = params.get("next") || "/festivalaki/registration-26-css";

	const [password, setPassword] = useState("");
	const [error, setError] = useState(null);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		let cancel = false;
		(async () => {
			const existing = sessionStorage.getItem(TOKEN_KEY);
			if (existing && (await validate(existing))) {
				if (!cancel) navigate(next, { replace: true });
			}
		})();
		return () => {
			cancel = true;
		};
	}, [navigate, next]);

	async function onSubmit(e) {
		e.preventDefault();
		setError(null);
		if (!password.trim()) return;
		setSubmitting(true);
		try {
			const r = await fetch(`${BASE}/access`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ password: password.trim() })
			});
			const j = await r.json();
			if (!r.ok) {
				setError(j.error || "Access denied");
				return;
			}
			sessionStorage.setItem(TOKEN_KEY, j.token);
			navigate(next, { replace: true });
		} catch {
			setError("Network error");
		} finally {
			setSubmitting(false);
		}
	}

	return (
		<div className="form-access page-container">
			<img src="/css.png" alt="decorative" className="css-title" />
			<h2>Internal Form Access</h2>
			<div className="form-container">
				<p className="lead-paragraph">
					This registration form is intended for CSS members. Please enter the password to continue.
					Access is limited to this browser tab and may be revoked if the password is rotated.
				</p>
				<form onSubmit={onSubmit} className="form-stack-sm">
					<label className="small-label">Password</label>
					<input
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
						autoComplete="off"
						className="access-input"
					/>
					{error && <p className="status-error no-margin">{error}</p>}
					<button disabled={submitting} type="submit" className="btn-dark">
						{submitting ? "Checking…" : "Unlock Form"}
					</button>
				</form>
			</div>
		</div>
	);
}
